import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiResponse } from '../shared/types';
import type { FamilyStartPreview, FamilyStartResult } from '../shared/types/family-start.types';

/** Start Family from an active membership (CWS-1581). */
@Injectable({ providedIn: 'root' })
export class FamilyStartService {
  constructor(private readonly api: ApiService) {}

  preview(subscriptionId: string): Observable<ApiResponse<FamilyStartPreview>> {
    return this.api.get<FamilyStartPreview>(`order/family-plan/start/${subscriptionId}`);
  }

  start(subscriptionId: string): Observable<ApiResponse<FamilyStartResult>> {
    return this.api.post<FamilyStartResult>(`order/family-plan/start/${subscriptionId}`, {});
  }
}
